"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var winston = __importStar(require("winston"));
/**
 * Create a logger instance to write log messages in JSON format.
 *
 * @param {string} loggerName - a name of a logger that will be added to all messages
 *
 * @category UTILS
 */


function createLogger(loggerName) {
  var level = 'info';

  if (process.env.NODE_ENV === 'test') {
    level = 'debug';
  }

  var logger = winston.createLogger({
    level: level,
    format: winston.format.combine(winston.format.colorize({
      all: true
    }), winston.format.simple()),
    defaultMeta: {
      name: loggerName
    },
    transports: [new winston.transports.Console()]
  });

  if (process.env.NODE_ENV === 'ci' || process.env.NODE_LOG === 'none') {
    logger.transports[0].silent = true;
  }

  return logger;
}

exports.default = createLogger;